import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { OperationSegmentSpec } from '../../process-plan'
import { OperationSegmentSpecDetailComponent } from '../operation-segment-spec-detail/operation-segment-spec-detail.component'

export interface IOperationSegmentDialogOptions {
  readonly operation: OperationSegmentSpec
}

@Component({
  selector: 'app-operation-segment-spec-detail-dialog',
  templateUrl: './operation-segment-spec-detail-dialog.component.html',
  styleUrls: ['./operation-segment-spec-detail-dialog.component.scss'],
  imports: [OperationSegmentSpecDetailComponent],
})
export class OperationSegmentSpecDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly original: OperationSegmentSpec
  public readonly copy: OperationSegmentSpec
  private dialogRef = inject<MatDialogRef<OperationSegmentSpecDetailDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IOperationSegmentDialogOptions>(MAT_DIALOG_DATA)
    this.copy = new OperationSegmentSpec()
    this.original = data.operation
    this.update(this.copy, this.original)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close()
  }

  public onSave($event: Event): void {
    this.update(this.original, this.copy)
    this.close(this.original)
  }

  public close(operation?: OperationSegmentSpec): void {
    this.dialogRef.close(operation)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private update(target: OperationSegmentSpec, source: OperationSegmentSpec): void {
    if (source?.action) {
      target.action = source.action
    }
  }
}
